import React from 'react';

export function CsfPivotalFournisseurEventRecognition() {

  return (
    <div className="modal fade" id="eventRecognitionModal" tabIndex="-1" role="dialog" aria-labelledby="eventRecognitionModalTitle"
         aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="eventRecognitionModalTitle">{window.Drupal.t('fournisseur.event.recognition.modal.title')}</h2>
            <button type="button" className="close" data-dismiss="modal" aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>

          <div className="modal-body">
            <div className="inner-wrapper" dangerouslySetInnerHTML={{__html: window.Drupal.t('fournisseur.event.recognition.modal.content')}}></div>
          </div>

          <div className="modal-footer d-flex justify-content-center">
            <button type="button" className="button btn-outlined btn-larger"
                    data-dismiss="modal">{window.Drupal.t('fournisseur.cancel.btn')}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
